import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import {RouterModule} from "@angular/router";
import { NotFoundComponent } from './not-found/not-found.component';
import { LoaderPlaceholderComponent } from './loader-placeholder/loader-placeholder.component';
import { OverlayWindowComponent } from './overlay-window/overlay-window.component';
import { OverlayWindowHeaderComponent } from './overlay-window/overlay-window-header/overlay-window-header.component';
import { OverlayWindowContentComponent } from './overlay-window/overlay-window-content/overlay-window-content.component';
import { OverlayWindowFooterComponent } from './overlay-window/overlay-window-footer/overlay-window-footer.component';
import { ShareOverlayComponent } from './share-overlay/share-overlay.component';
import { StoryShareOverlayComponent } from './story-share-overlay/story-share-overlay.component';
import {AtomsModule} from "../atoms/atoms.module";
import { SubmenuItemComponent } from './header/submenu-item/submenu-item.component';
import {DirectivesModule} from "../directives/directives.module";
import { RoughHeadlineComponent } from './rough-headline/rough-headline.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import {BreadcrumbModule} from "xng-breadcrumb";
import { SubNavigationComponent } from './sub-navigation/sub-navigation.component';
import { LottieComponent } from './lottie/lottie.component';
import {LottieModule} from "ngx-lottie";
import { ArchivePaginationComponent } from './archive-pagination/archive-pagination.component';
import {FormsModule} from "@angular/forms";
import { ContactPersonComponent } from './contact-person/contact-person.component';
import { ContactLinkComponent } from './contact-link/contact-link.component';
import { FooterComponent } from './footer/footer.component';
import { HtmlWrapperComponent } from './html-wrapper/html-wrapper.component';
import { GalleryComponent } from './gallery/gallery.component';
import { GalleryItemComponent } from './gallery/gallery-item/gallery-item.component';
import {EmbedVideoModule} from "../embed-video/embed-video.module";
import { GallerySliderComponent } from './gallery-slider/gallery-slider.component';
import {SwiperModule} from "swiper/angular";
import {HttpBackend} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import { YoutubeVideoOverlayComponent } from './youtube-video-overlay/youtube-video-overlay.component';
import { LogoSliderComponent } from './logo-slider/logo-slider.component';
import { FilteredLinksListComponent } from './filtered-links-list/filtered-links-list.component';
import { MobileHeaderComponent } from './header/mobile-header/mobile-header.component';
import { WizardIconComponent } from './header/wizard-icon/wizard-icon.component';
import { FavoritesIconComponent } from './header/favorites-icon/favorites-icon.component';
import {GalleryPreviewComponent} from "./gallery-preview/gallery-preview.component";
import {LogoComponent} from "./logo/logo.component";
import {MultiTranslateHttpLoader} from "ngx-translate-multi-http-loader";
import { AlertComponent } from './alert/alert.component';
import { SliderInputComponent } from './slider-input/slider-input.component';
import { InterestFieldCardComponent } from './interest-field-card/interest-field-card.component';
import { EventPreviewComponent } from './event-preview/event-preview.component';
import { ContactPersonsComponent } from './contact-persons/contact-persons.component';
import { CookieComponent } from './cookie/cookie.component';
import { CodeInputComponent } from './code-input/code-input.component';
import { LargeMessageComponent } from './large-message/large-message.component';
import { DotLottieComponent } from './dot-lottie/dot-lottie.component';
import { TimerButtonComponent } from './timer-button/timer-button.component';
import { HeaderHomeBoxComponent } from './header/header-home-box/header-home-box.component';
import { HeaderOrganizationDataComponent } from './header/header-organization-data/header-organization-data.component';
import { GameStatusBannerComponent } from './game-status-banner/game-status-banner.component';
import { DashboardBoxesHeadComponent } from './dashboard-boxes-head/dashboard-boxes-head.component';
import { GamesListComponent } from './games-list/games-list.component';
import { GamePreviewComponent } from './game-preview/game-preview.component';
import { RankingListComponent } from './ranking-list-block/ranking-list/ranking-list.component';
import { RankingListItemComponent } from './ranking-list-block/ranking-list/ranking-list-item/ranking-list-item.component';
import { RankingListBlockComponent } from './ranking-list-block/ranking-list-block.component';
import { RankingListOverlayHeaderComponent } from './ranking-list-block/ranking-list/ranking-list-overlay-header/ranking-list-overlay-header.component';
import { RankingListOverlayFooterComponent } from './ranking-list-block/ranking-list/ranking-list-overlay-footer/ranking-list-overlay-footer.component';
import { OrganizationTrophiesBlockComponent } from './organization-trophies-block/organization-trophies-block.component';
import { TrophiesListComponent } from './organization-trophies-block/trophies-list/trophies-list.component';
import { TrophiesListItemComponent } from './organization-trophies-block/trophies-list/trophies-list-item/trophies-list-item.component';
import { OrganizationTrophiesOverlayHeaderComponent } from './organization-trophies-block/organization-trophies-overlay-header/organization-trophies-overlay-header.component';
import { OrganizationTrophiesOverlayFooterComponent } from './organization-trophies-block/organization-trophies-overlay-footer/organization-trophies-overlay-footer.component';
import { ExperienceProgressComponent } from './experience-progress/experience-progress.component';
import { MobileGameHeaderMenuComponent } from './header/mobile-game-header-menu/mobile-game-header-menu.component';
import { ChartComponent } from './chart/chart.component';
import { StatisticsBlockComponent } from './statistics-block/statistics-block.component';
import { PieChartComponent } from './chart/pie-chart/pie-chart.component';
import { StatisticsLineChartBlockComponent } from './statistics-line-chart-block/statistics-line-chart-block.component';
import { LineChartComponent } from './chart/line-chart/line-chart.component';
import { ClassMainStatisticsBlockComponent } from './class-main-statistics-block/class-main-statistics-block.component';
import { MiniChartComponent } from './chart/mini-chart/mini-chart.component';
import { GameCategoriesSelectorComponent } from './game-categories-selector/game-categories-selector.component';
import { GameCategoryPreviewComponent } from './game-categories-selector/game-category-preview/game-category-preview.component';
import { TeacherGameSetupOverlayFooterComponent } from './teacher-game-setup-overlay-footer/teacher-game-setup-overlay-footer.component';
import { TeacherGameSetupOverlayHeaderComponent } from './teacher-game-setup-overlay-header/teacher-game-setup-overlay-header.component';
import {PipesModule} from "../pipes/pipes.module";
import { TeacherTimerSetupComponent } from './teacher-timer-setup/teacher-timer-setup.component';
import { AlertLargeComponent } from './alert-large/alert-large.component';
import { AlertLargeFooterComponent } from './alert-large/alert-large-footer/alert-large-footer.component';
import { SchoolClassCompareBlockComponent } from './school-class-compare-block/school-class-compare-block.component';
import { SchoolClassCompareBlockLegendComponent } from './school-class-compare-block/school-class-compare-block-legend/school-class-compare-block-legend.component';
import { SchoolClassCompareBlockCategoriesComponent } from './school-class-compare-block/school-class-compare-block-categories/school-class-compare-block-categories.component';
import { SchoolClassCompareBlockChartComponent } from './school-class-compare-block/school-class-compare-block-chart/school-class-compare-block-chart.component';
import { SchoolClassCompareBlockTrophiesComponent } from './school-class-compare-block/school-class-compare-block-trophies/school-class-compare-block-trophies.component';
import { GameCategoriesSelectorFooterStudentComponent } from './game-categories-selector/game-categories-selector-footer-student/game-categories-selector-footer-student.component';
import { ContentTabsComponent } from './content-tabs/content-tabs.component';
import { TeacherDashboardBlockComponent } from './teacher-dashboard-block/teacher-dashboard-block.component';
import { UsefillLinkComponent } from './usefill-link/usefill-link.component';
import { EventMiniPreviewComponent } from './event-mini-preview/event-mini-preview.component';
import { SchoolClassMiniPreviewComponent } from './school-class-mini-preview/school-class-mini-preview.component';
import { PieStatisticsComponent } from './pie-statistics/pie-statistics.component';
import { EducationIdeaComponent } from './education-idea/education-idea.component';
import { KeyValueItemComponent } from './key-value-item/key-value-item.component';
import { StatisticsItemComponent } from './statistics-item/statistics-item.component';
import { StatisticsItemCollectionComponent } from './statistics-item-collection/statistics-item-collection.component';
import { MilestonesProgressOverlayComponent } from './milestones-progress-overlay/milestones-progress-overlay.component';
import { MilestonesProgressOverlayFooterComponent } from './milestones-progress-overlay/milestones-progress-overlay-footer/milestones-progress-overlay-footer.component';
import { EventPreviewsListModalComponent } from './event-previews-list-modal/event-previews-list-modal.component';
import { DialogWindowComponent } from './dialog-window/dialog-window.component';
import { PromptTextComponent } from './prompt-text/prompt-text.component';
import { DateRangeInputModalComponent } from './date-range-input-modal/date-range-input-modal.component';
import { QuestsListComponent } from './quests-list/quests-list.component';
import { QuestListItemComponent } from './quests-list/quest-list-item/quest-list-item.component';
import { AccessibilityMenuComponent } from './accessibility-menu/accessibility-menu.component';
import {SearchFilterModule} from "../search-filter/search-filter.module";

export function HttpLoaderFactory(_httpBackend: HttpBackend) {
  return new MultiTranslateHttpLoader(_httpBackend, [
    {prefix: '/assets/i18n/core/', suffix: '.json'},
    {prefix: '/assets/i18n/header/', suffix: '.json'},
    {prefix: '/assets/i18n/home/', suffix: '.json'},
    {prefix: '/assets/i18n/professions/', suffix: '.json'},
    {prefix: '/assets/i18n/footer/', suffix: '.json'},
    {prefix: '/assets/i18n/profession-details/', suffix: '.json'},
    {prefix: '/assets/i18n/providers/', suffix: '.json'},
    {prefix: '/assets/i18n/insights/', suffix: '.json'},
    {prefix: '/assets/i18n/jobs/', suffix: '.json'},
    {prefix: '/assets/i18n/teacher-dashboard/', suffix: '.json'},
    {prefix: '/assets/i18n/user-dashboard/', suffix: '.json'},
    {prefix: '/assets/i18n/class-dashboard/', suffix: '.json'},
    {prefix: '/assets/i18n/accessibility/', suffix: '.json'},
    {prefix: '/assets/i18n/rookie/', suffix: '.json'},
    {prefix: '/assets/i18n/rookieday/', suffix: '.json'}
  ]);
}

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  declarations: [
    HeaderComponent,
    NotFoundComponent,
    LoaderPlaceholderComponent,
    OverlayWindowComponent,
    OverlayWindowHeaderComponent,
    OverlayWindowContentComponent,
    OverlayWindowFooterComponent,
    ShareOverlayComponent,
    StoryShareOverlayComponent,
    SubmenuItemComponent,
    RoughHeadlineComponent,
    BreadcrumbComponent,
    SubNavigationComponent,
    LottieComponent,
    ArchivePaginationComponent,
    ContactPersonComponent,
    ContactLinkComponent,
    FooterComponent,
    HtmlWrapperComponent,
    GalleryComponent,
    GalleryItemComponent,
    GallerySliderComponent,
    YoutubeVideoOverlayComponent,
    LogoSliderComponent,
    FilteredLinksListComponent,
    MobileHeaderComponent,
    WizardIconComponent,
    FavoritesIconComponent,
    GalleryPreviewComponent,
    LogoComponent,
    AlertComponent,
    SliderInputComponent,
    InterestFieldCardComponent,
    EventPreviewComponent,
    ContactPersonsComponent,
    CookieComponent,
    CodeInputComponent,
    LargeMessageComponent,
    DotLottieComponent,
    TimerButtonComponent,
    HeaderHomeBoxComponent,
    HeaderOrganizationDataComponent,
    GameStatusBannerComponent,
    DashboardBoxesHeadComponent,
    GamesListComponent,
    GamePreviewComponent,
    RankingListComponent,
    RankingListItemComponent,
    RankingListBlockComponent,
    RankingListOverlayHeaderComponent,
    RankingListOverlayFooterComponent,
    OrganizationTrophiesBlockComponent,
    TrophiesListComponent,
    TrophiesListItemComponent,
    OrganizationTrophiesOverlayHeaderComponent,
    OrganizationTrophiesOverlayFooterComponent,
    ExperienceProgressComponent,
    MobileGameHeaderMenuComponent,
    ChartComponent,
    StatisticsBlockComponent,
    PieChartComponent,
    StatisticsLineChartBlockComponent,
    LineChartComponent,
    ClassMainStatisticsBlockComponent,
    MiniChartComponent,
    GameCategoriesSelectorComponent,
    GameCategoryPreviewComponent,
    TeacherGameSetupOverlayFooterComponent,
    TeacherGameSetupOverlayHeaderComponent,
    TeacherTimerSetupComponent,
    AlertLargeComponent,
    AlertLargeFooterComponent,
    SchoolClassCompareBlockComponent,
    SchoolClassCompareBlockLegendComponent,
    SchoolClassCompareBlockCategoriesComponent,
    SchoolClassCompareBlockChartComponent,
    SchoolClassCompareBlockTrophiesComponent,
    GameCategoriesSelectorFooterStudentComponent,
    ContentTabsComponent,
    TeacherDashboardBlockComponent,
    UsefillLinkComponent,
    EventMiniPreviewComponent,
    SchoolClassMiniPreviewComponent,
    PieStatisticsComponent,
    EducationIdeaComponent,
    KeyValueItemComponent,
    StatisticsItemComponent,
    StatisticsItemCollectionComponent,
    MilestonesProgressOverlayComponent,
    MilestonesProgressOverlayFooterComponent,
    EventPreviewsListModalComponent,
    DialogWindowComponent,
    PromptTextComponent,
    DateRangeInputModalComponent,
    QuestsListComponent,
    QuestListItemComponent,
    AccessibilityMenuComponent,
  ],
    exports: [
        HeaderComponent,
        LoaderPlaceholderComponent,
        OverlayWindowComponent,
        ShareOverlayComponent,
        RoughHeadlineComponent,
        BreadcrumbComponent,
        SubNavigationComponent,
        LottieComponent,
        ArchivePaginationComponent,
        ContactPersonComponent,
        ContactLinkComponent,
        FooterComponent,
        OverlayWindowHeaderComponent,
        TranslateModule,
        GalleryItemComponent,
        LogoSliderComponent,
        FilteredLinksListComponent,
        MobileHeaderComponent,
        SubmenuItemComponent,
        GalleryPreviewComponent,
        LogoComponent,
        SliderInputComponent,
        InterestFieldCardComponent,
        EventPreviewComponent,
        ContactPersonsComponent,
        GameStatusBannerComponent,
        GamesListComponent,
        RankingListComponent,
        RankingListBlockComponent,
        OrganizationTrophiesBlockComponent,
        ExperienceProgressComponent,
        TimerButtonComponent,
        MobileGameHeaderMenuComponent,
        ChartComponent,
        StatisticsBlockComponent,
        StatisticsLineChartBlockComponent,
        ClassMainStatisticsBlockComponent,
        GameCategoriesSelectorComponent,
        TeacherTimerSetupComponent,
        DashboardBoxesHeadComponent,
        SchoolClassCompareBlockComponent,
        ContentTabsComponent,
        TeacherDashboardBlockComponent,
        UsefillLinkComponent,
        EventMiniPreviewComponent,
        SchoolClassMiniPreviewComponent,
        PieStatisticsComponent,
        EducationIdeaComponent,
        KeyValueItemComponent,
        StatisticsItemComponent,
        StatisticsItemCollectionComponent,
        DotLottieComponent,
        FavoritesIconComponent,
        WizardIconComponent,
        CodeInputComponent,
    ],
  imports: [
    CommonModule,
    RouterModule,
    AtomsModule,
    DirectivesModule,
    BreadcrumbModule,
    LottieModule,
    FormsModule,
    EmbedVideoModule,
    SwiperModule,
    TranslateModule.forChild({
      defaultLanguage: 'de',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    PipesModule,
    SearchFilterModule
  ]
})
export class SharedModule { }
